export default "__VITE_ASSET__da8bc12b__"